
import { Group, Line } from 'react-konva';
import { KONVA_FACET_GROUP } from '../../../constants';
import { KonvaGroupNames } from '../utils';
import { useKonvaImageScale } from 'contexts/ToolDimensionsAndScaleContext';
import { GUTTER_LINE_CONFIG } from './constant';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { buildAllGuttersMitered } from './GutterUtils';
import { selectFilteredGutterLines } from 'store/slices/RoofDataSlice/roofSelector';

export default function GutterLines() {
	const filteredGutterLines = useSelector(selectFilteredGutterLines);
	const { enableEditFacet } = useSelector((state: RootState) => state.roofEditData.data);
	const { activeRoofTool } = useSelector((state: RootState) => state.roofToolLines.data);

	const scale = useKonvaImageScale();
	const gutters = buildAllGuttersMitered(filteredGutterLines);

	return (
		<Group
			visible= {!enableEditFacet && !activeRoofTool}
			scale={scale}
			name={`gutter-lines${KONVA_FACET_GROUP.GROUP_NAME_SEPARATOR}${KONVA_FACET_GROUP.EXISTING_GROUP_NAME}`}
			listening={false}
		>

			{ gutters?.map((line, index) => (
				<Line
					key={index}
					name={`${KonvaGroupNames.existingFacetsGroup}${KONVA_FACET_GROUP.GROUP_NAME_SEPARATOR}gutter-line`}
					id={`${index}`}
					closed={true}
					strokeWidth={GUTTER_LINE_CONFIG.viewStrokeWidth}
					points={line.coords.flat()}
					draggable={false}
					stroke={GUTTER_LINE_CONFIG.color}
					listening={false}
					strokeScaleEnabled={false}
				/>
			))
			}

		</Group>
	);
}
